import { Network } from '@spritz-finance/sdk'
import { BigNumber } from 'ethers'
import React from 'react'
import { useTokenBalance } from './useTokenBalance'

export type TokenDetails = {
    address: string
    wallet?: string
    network: Network
    symbol?: string | null
}

interface ITokenBalanceContext {
    balance?: BigNumber
}

export const TokenBalanceContext = React.createContext<ITokenBalanceContext>(
    {} as ITokenBalanceContext
)

export const useTokenBalanceContext = () => {
    const context = React.useContext(TokenBalanceContext)
    if (!context)
        throw new Error('Cannot use useAllowanceContext outside of a <AllowanceProvider />')
    return context
}

export const TokenBalanceProvider: React.FC<{
    token: TokenDetails
}> = ({ token, children }) => {
    const { balance } = useTokenBalance(token)
    return (
        <TokenBalanceContext.Provider value={{ balance }}>{children}</TokenBalanceContext.Provider>
    )
}
